import { SET_LEADS_CUSTOMER_VALUATION_REQUEST, SET_LEADS_CUSTOMER_VALUATION_REQUEST_SUCCESS, SET_LEADS_CUSTOMER_VALUATION_REQUEST_FAILURE } from '../constants/set_customer_valuation.constants';

export const setLeadsCustomerValuationRequest = (lead_id, customer_valuation, selling_reason, customer_valuation_by, customer_valuation_date, close_reason) => ({
    type: SET_LEADS_CUSTOMER_VALUATION_REQUEST, lead_id, customer_valuation, selling_reason, customer_valuation_by, customer_valuation_date, close_reason,
});
export const setLeadsCustomerValuationRequestSuccess = (customer_valuation, selling_reason, customer_valuation_by, customer_valuation_date, close_reason) => ({
    type: SET_LEADS_CUSTOMER_VALUATION_REQUEST_SUCCESS, customer_valuation, selling_reason, customer_valuation_by, customer_valuation_date, close_reason,
});
export const setLeadsCustomerValuationRequestFailure = error => ({ type: SET_LEADS_CUSTOMER_VALUATION_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/set_customer_valuation.actions.js